import * as ActionTypes from 'state/types'

const initialState = {
  isRequesting: false,
  isFailure: false,
  collection: []
}

export default (state = initialState, action) => {
  switch (action.type) {
    case `${ActionTypes.FETCH_SETTINGS_INBOXES_OPTIONS_REQUEST}_START`: {
      return {
        ...state,
        isRequesting: true,
        isFailure: false,
        collection: []
      }
    }

    case `${ActionTypes.FETCH_SETTINGS_INBOXES_OPTIONS_REQUEST}_SUCCESS`: {
      const {
        items
      } = action.response

      return {
        ...state,
        isRequesting: false,
        isFailure: false,
        collection: items
      }
    }

    case `${ActionTypes.FETCH_SETTINGS_INBOXES_OPTIONS_REQUEST}_FAIL`: {
      return {
        ...state,
        isRequesting: false,
        isFailure: true
      }
    }

    case `${ActionTypes.SETTINGS_INBOXES_SAVE_REQUEST}_START`: {
      return {
        ...state,
        isRequesting: true,
        isFailure: false
      }
    }
    case `${ActionTypes.SETTINGS_INBOXES_SAVE_REQUEST}_SUCCESS`: {
      return {
        ...state,
        isRequesting: false,
        isFailure: false
      }
    }
    case `${ActionTypes.SETTINGS_INBOXES_SAVE_REQUEST}_FAIL`: {
      return {
        ...state,
        isRequesting: false,
        isFailure: true
      }
    }

    case ActionTypes.SETTINGS_INBOXES_ON_TOGGLE: {
      const { itemIndex, inboxIndex } = action.payload
      const copiedCollection = [ ...state.collection ]

      const nextCheckedState = !copiedCollection[itemIndex].inboxes[inboxIndex].checked

      copiedCollection[itemIndex].inboxes[inboxIndex].checked = nextCheckedState

      return {
        ...state,
        collection: copiedCollection
      }
    }

    default:
      return state
  }
}
